export default __webpack_public_path__ + "static/media/icon-feature2.7c45e9e6.svg";